export default __webpack_public_path__ + "static/lookbook-4-ee0745174bd95ab112634194de9b4ce4.webp";